import React from "react";
import { IBannerEstatico } from "./BannerEstatico.interface";

import styles from "./BannerEstatico.module.scss";

interface IBannerEstaticoProps {
	dataBannerEstatico: IBannerEstatico
}
const toctocImg = process.env.NEXT_PUBLIC_URL_TOCTOCIMG_BPL;

export const BannerEstatico = ({ dataBannerEstatico }: IBannerEstaticoProps) => {
	if (dataBannerEstatico === null || dataBannerEstatico === undefined || Object.keys(dataBannerEstatico).length === 0) return null
	const { titulo, texto, img, alt } = dataBannerEstatico;
	return (
		<article className={styles.cBannerEstatico}>
			{img && <img className={styles.imgEstatico} src={img} alt={alt} />}
			<div className={styles.cTextoEstatico}>
				<p className={styles.tituloEstatico}>{titulo}</p>
				<p className={styles.textoEstatico}>{texto}</p>
				<div className={styles.cLogos}>
					<img
						className={styles.logoTT}
						src={`${toctocImg}toctoc/img/logos/brand/logo-tt-h.svg`}
						alt="Logo-toctoc"
					/>
					<img
						className={styles.bplLogo}
						src={`${toctocImg}toctocseo/img/logo_bptl.svg`}
						alt="Logo-BPL"
					/>
				</div>
			</div>
		</article>
	);
};
